// extracted by mini-css-extract-plugin
export default {"HomeHeader":"homeHeader_HomeHeader__Fg9--","Block":"homeHeader_Block__gBsPD","Block__Title":"homeHeader_Block__Title__FegH5","SignUp":"homeHeader_SignUp__ajN72"};